'use client';

import { useEffect } from 'react';
import { freezeScroll, releaseScroll } from 'app/utility/helpers';

let lockCount = 0;

export default function LockBodyScroll() {
  useEffect(() => {
    lockCount = lockCount + 1;
    freezeScroll();
    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        releaseScroll();
      }
    };
  }, []);

  return null;
}
